import React, { useEffect, useRef, useState } from 'react';

export default function SharePointApprovalButton({
  children,
  onApprove,
  previewVersion,
  disabled,
  allowOriginal = true,
  originalActionLabel = 'Approve & Push (unredacted)',
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!menuOpen) return undefined;
    const closeOutside = (event) => {
      if (!containerRef.current?.contains(event.target)) setMenuOpen(false);
    };
    const closeOnEscape = (event) => {
      if (event.key === 'Escape') {
        setMenuOpen(false);
        containerRef.current?.querySelector('[aria-haspopup]')?.focus();
      }
    };
    document.addEventListener('mousedown', closeOutside);
    document.addEventListener('keydown', closeOnEscape);
    return () => {
      document.removeEventListener('mousedown', closeOutside);
      document.removeEventListener('keydown', closeOnEscape);
    };
  }, [menuOpen]);

  return (
    <div className="btn-group position-relative" ref={containerRef}>
      <button
        type="button"
        className="btn btn-success"
        onClick={() => onApprove(previewVersion)}
        disabled={disabled}
      >
        {children}
      </button>
      {allowOriginal && (
        <>
          <button
            type="button"
            className="btn btn-outline-success dropdown-toggle"
            aria-label="More approval options"
            aria-haspopup="menu"
            aria-expanded={menuOpen}
            disabled={disabled}
            onClick={() => setMenuOpen((open) => !open)}
          >
            Unredacted
          </button>
          {menuOpen && !disabled && (
            <div className="dropdown-menu dropdown-menu-end show" role="menu" style={{ top: '100%', right: 0 }}>
              <button
                type="button"
                className="dropdown-item"
                role="menuitem"
                onClick={() => {
                  setMenuOpen(false);
                  onApprove('original');
                }}
              >
                {originalActionLabel}
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
